export enum DuplicationResult {
    Duplicate = 'duplicate',
    Cleared = 'cleared',
    Error = 'error',
}
